<template>
  <section>
    <div class="has-text-centered">
      <p class="subtitle">RELATED ORDERS</p>
    </div>
    <div class="family-tree">
      <order-family-tree-nodes :order="order" :nodes="nodes"/>
    </div>
  </section>
</template>

<script>
import OrderFamilyTreeNodes from "./OrderFamilyTreeNodes";
import { OrderService } from "@/services/order.service";

export default {
  orderService: OrderService,
  props: {
    order: {
      required: true
    }
  },
  components: {
    OrderFamilyTreeNodes
  },
  data: () => ({
    nodes: [],
    isLoading: false
  }),
  created() {
    this.fetchNodes();
  },
  methods: {
    async fetchNodes() {
      if (this.order) {
        this.isLoading = true;
        const parentNode = await this.$options.orderService
          .listHierarchy(this.order.id)
          .then(response => response.data.data);

        this.nodes = parentNode ? [parentNode] : [];
        this.isLoading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderFamilyTree.vue